import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'DeLonghiSerif', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'Google Sans Flex', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'DeLonghiSerif', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'Google Sans Flex', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
